import { render, staticRenderFns } from "./AdGroupSimpleEditor.vue?vue&type=template&id=5087b04c&scoped=true"
import script from "./AdGroupSimpleEditor.vue?vue&type=script&lang=js"
export * from "./AdGroupSimpleEditor.vue?vue&type=script&lang=js"
import style0 from "./AdGroupSimpleEditor.vue?vue&type=style&index=0&id=5087b04c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087b04c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5087b04c')) {
      api.createRecord('5087b04c', component.options)
    } else {
      api.reload('5087b04c', component.options)
    }
    module.hot.accept("./AdGroupSimpleEditor.vue?vue&type=template&id=5087b04c&scoped=true", function () {
      api.rerender('5087b04c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/groupBanner/AdGroupSimpleEditor.vue"
export default component.exports